var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"pagination",attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":_vm.pageSize,"layout":_vm.layout,"total":_vm.total},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }